define(function(require) {
    var $ = require("jquery");
    $(document).ready(function() {
        $(".countdown-banner").addClass("active");
    });
});
